import { createApi } from "@reduxjs/toolkit/query/react";

import { EVENT_TYPE } from "@/constants/calendar.constants";
import { ICalendarItem, TCalendar } from "@/interfaces/calendar.interface";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

export const calendarApi = createApi({
  reducerPath: "calendarApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["calendar", "event", "meeting"],
  endpoints: (builder) => ({
    getCalendarEventsAndMeetings: builder.query<
      GeneralResponse<TCalendar>,
      { type: EVENT_TYPE; filter: string }
    >({
      query: ({ type, filter }) => {
        return `/workspace/${getWorkspace()}/calendar?type=${type}${filter ? `${filter}` : ""}`;
      },
      providesTags: ["calendar"],
    }),
    createCalendarEventORMeeting: builder.mutation<object, { data: object }>({
      query: ({ data }) => ({
        url: `/workspace/${getWorkspace()}/calendar`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["calendar"],
    }),
    getSingleEventOrMeeting: builder.query<ICalendarItem, { id: string }>({
      query: ({ id }) => `/workspace/${getWorkspace()}/calendar/${id}`,
      providesTags: ["calendar"],
      transformResponse: (response: APIResponse<ICalendarItem>) =>
        response?.data,
    }),
    alterEventOrMeeting: builder.mutation<
      object,
      { id: string; data?: object; method: "PUT" | "DELETE" }
    >({
      query: ({ id, data, method }) => ({
        url: `/workspace/${getWorkspace()}/calendar/${id}`,
        method,
        body: data,
      }),
      invalidatesTags: ["calendar"],
    }),
  }),
});

export const {
  useGetCalendarEventsAndMeetingsQuery,
  useCreateCalendarEventORMeetingMutation,
  useGetSingleEventOrMeetingQuery,
  useAlterEventOrMeetingMutation,
} = calendarApi;
